import {
  alpha,
  ToggleButton as MuiToggleButton,
  ToggleButtonGroup as MuiToggleButtonGroup,
  styled,
} from '@mui/material';

import { LARGE_RADIUS_PX, SMALL_MARGIN_PX, SUBMIDDLE_MARGIN_PX } from '~/theme';

const StyledToggleButtonGroup = styled(MuiToggleButtonGroup)`
  width: 100%;
`;
const StyledToggleButton = styled(MuiToggleButton)`
  background-color: ${({ theme }) => theme.palette.common.blackSecondary};
  border-radius: ${LARGE_RADIUS_PX};
  border: 0;
  color: ${({ theme }) => theme.palette.common.text.gray};
  flex-grow: 1;
  font-size: 14px;
  font-weight: 700;
  line-height: 18px;
  padding: ${SMALL_MARGIN_PX} ${SUBMIDDLE_MARGIN_PX};
  text-transform: none;
  transition: 0.3s background-color;
  max-height: 48px;
  transition: 0.3s all;

  &:hover {
    background-color: ${({ theme }) => alpha(theme.palette.common.blackSecondary, 0.9)};
    color: ${({ theme }) => theme.palette.common.white};
  }

  &.Mui-selected {
    color: ${({ theme }) => theme.palette.common.text.white};
    background-color: ${({ theme }) => theme.palette.common.violetAnalyticsCard};

    &:hover {
      background-color: ${({ theme }) => alpha(theme.palette.common.violetAnalyticsCard, 0.9)};
    }
  }

  &.MuiToggleButtonGroup-grouped:not(:first-of-type) {
    border-left: 0;
    margin-left: 0;
  }
`;

export { StyledToggleButton as ToggleButton, StyledToggleButtonGroup as ToggleButtonGroup };
